import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import HotSection from './components/HotSection';
import LatestSection from './components/LatestSection';
import RecommendedSection from './components/RecommendedSection';
import FeaturesSection from './components/FeaturesSection';

export default function Home() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return (
    <main className="min-h-screen bg-background-950">
      <Navbar />
      <HeroBanner />
      <CategoryNav />
      <HotSection />
      <RecommendedSection />
      <LatestSection />
      <FeaturesSection />
      <Footer />
    </main>
  );
}